var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : !_vm.attributeValues.length ? _c('i', [_vm._v("Geen informatie gevonden")]) : _c('div', [_c('b-table', {
    staticClass: "mt-2",
    attrs: {
      "fields": _vm.productAttributeTableFields,
      "items": _vm.attributeValues,
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(value)",
      fn: function (data) {
        var _data$item$product_at;
        return [data.item.component ? _c(data.item.component, {
          tag: "component",
          attrs: {
            "product-identifier": _vm.number
          }
        }) : ((_data$item$product_at = data.item.product_attribute) === null || _data$item$product_at === void 0 ? void 0 : _data$item$product_at.identifier) === 'image_url' ? _c('span', [_c('b-link', {
          on: {
            "click": function ($event) {
              _vm.isImageModalOpen = true;
            }
          }
        }, [_c('img', {
          staticClass: "product-image",
          attrs: {
            "src": data.item.value,
            "alt": ""
          }
        })]), _c('b-modal', {
          attrs: {
            "title": `Afbeelding voor product ${_vm.number}`,
            "size": "xl",
            "hide-footer": "",
            "body-class": "product-image-container"
          },
          model: {
            value: _vm.isImageModalOpen,
            callback: function ($$v) {
              _vm.isImageModalOpen = $$v;
            },
            expression: "isImageModalOpen"
          }
        }, [_c('img', {
          staticClass: "product-image-large",
          attrs: {
            "src": data.item.value,
            "alt": ""
          }
        })])], 1) : _c('span', {
          domProps: {
            "innerHTML": _vm._s(data.value)
          }
        })];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }